<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <br />
    <div class="main-h">
      <router-link
        :to="'/role-links/student/start-exam'"
        style="text-decoration: none"
        class="root"
      >
        <v-icon left color="white" class="home-icon"
          >mdi-keyboard-backspace</v-icon
        >
        <span class="home-text"><strong>Home</strong></span>
      </router-link>
    </div>
    <br /><br />
    <v-row class="justify-center">
      <v-card elevation="3" v-if="basic_info != ''">
        <v-card-title class="justify-center"> {{exam}} Exam Result </v-card-title>
        <v-card-text>
          <div class="box">
            <template>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Gr.No.</th>
                      <th class="text-left">Student Name</th>
                      <th class="text-left">Program</th>
                      <th class="text-left">Year</th>
                      <th class="text-left">Organization</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in basic_info" :key="item.name">
                      <td>{{ item.registration_no }}</td>
                      <td>{{ item.student_name }}</td>
                      <td>{{ item.program }}</td>
                      <td>{{ item.year }}</td>
                      <td>{{ item.organization }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </template>
          </div>
        </v-card-text>
      </v-card>
    </v-row>
    <br />
    <v-row class="justify-center">
      <v-card elevation="2" v-if="marks_info != ''">
        <v-card-text>
          <div class="box">
            <template>
              <v-data-table
                :headers="headers"
                :items="marks_info"
                :items-per-page="5"
                class="elevation-1 mytable"
              ></v-data-table>
            </template>
          </div>
        </v-card-text>
      </v-card>
    </v-row>
    <v-overlay :value="overlay">
      <v-progress-circular
        class="text-center"
        :size="70"
        :width="5"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import "@/assets/css/color.css";
import axios from "axios";
export default {
  data: () => ({
    summary: "",
    exam:'',
    basic_info: "",
    marks_info: "",
    overlay: false,
    headers: [
      {
        text: "Course Code",
        align: "start",
        sortable: false,
        value: "course_code",
      },
      { text: "Course Name", value: "course_name" },
      { text: "Marks", value: "marks" },
    ],
    snackbar_msg: "",
    color: "",
    snackbar: false,
  }),
  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.overlay = true;
    this.summary = JSON.parse(localStorage.getItem("summury_id"));
    // window.alert(this.summary);
    const data = {
      summary_id: this.summary,
    };
    axios
      .post("/Student/StudentResult", data)
      .then((res) => {
        this.overlay = false;
        if (res.data.msg == "200") {
          if (res.data.status == "NO") {
            this.showSnackbar(
              "#b71c1c",
              "Something went wrong, Please try again later!"
            ); // show snackbar
          }
          this.exam = res.data.exam
          this.basic_info = res.data.basic_info;
          this.marks_info = res.data.arrayList1;
        } else {
          this.overlay = false;
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        }
      })
      .catch((error) => {
        this.overlay = false;
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
      })
      .finally(() => {
        this.overlay = false;
      });
  },
};
</script>

<style>
.box {
  background-color: #add8e630;
  margin: 8px;
  padding: 8px;
}

.v-progress-circular {
  margin: 2rem;
}
.main-h {
  display: flex;
  justify-content: space-between;
  padding: 1rem 1rem 1.5rem 1rem;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
  background: linear-gradient(
    130deg,
    hsla(190, 99%, 30%, 1) 0%,
    hsla(226, 50%, 65%, 1) 180%
  );
}
.home-text {
  color: white;
  margin-top: 3px !important;
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 2rem;
}
</style>